var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('CoreNavigation'),_c('CoreView'),_c('CoreFooter'),_c('MsgBar',{ref:"MsgBarRef"}),_c('PushMessageReq',{ref:"PushMessageReqRef"}),_c('SensorState',{ref:"SensorStateRef"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }